// @flow
import {
    INIT_MENU,
    INIT_MENU_SUCCESS,
    CHANGE_ACTIVE_MENU_FROM_LOCATION,
    CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS,
    FETCH_MAINTENANCE_REQUEST_BADGE,
    FETCH_CHAT_USER_BADGE,
    FETCH_CHAT_TECHNICIAN_BADGE,
    FETCH_MAINTENANCE_REQUEST_BADGE_SUCCESS,
    FETCH_CHAT_USER_BADGE_SUCCESS,
    FETCH_CHAT_TECHNICIAN_BADGE_SUCCESS,
} from './constants';

export const initMenu = () => ({
    type: INIT_MENU,
    payload: {},
});

export const initMenuSuccess = (menuItems) => ({
    type: INIT_MENU_SUCCESS,
    payload: { menuItems },
});

export const changeActiveMenuFromLocation = () => ({
    type: CHANGE_ACTIVE_MENU_FROM_LOCATION,
    payload: {},
});

export const changeActiveMenuFromLocationSuccess = (activatedMenuItemIds) => ({
    type: CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS,
    payload: { activatedMenuItemIds },
});

export const fetchMaintenanceRequestBadge = () => ({
    type: FETCH_MAINTENANCE_REQUEST_BADGE,
    payload: {},
});

export const fetchMaintenanceRequestBadgeSuccess = (badgeMaintenance) => ({
    type: FETCH_MAINTENANCE_REQUEST_BADGE_SUCCESS,
    payload: {badgeMaintenance},
});

export const fetchChatUserBadge = () => ({
    type: FETCH_CHAT_USER_BADGE,
    payload: {},
});

export const fetchChatUserBadgeSuccess = (badgeChatUser) => ({
    type: FETCH_CHAT_USER_BADGE_SUCCESS,
    payload: {badgeChatUser},
});

export const fetchChatTechnicianBadge = () => ({
    type: FETCH_CHAT_TECHNICIAN_BADGE,
    payload: {},
});

export const fetchChatTechnicianBadgeSuccess = (badgeChatTechnician) => ({
    type: FETCH_CHAT_TECHNICIAN_BADGE_SUCCESS,
    payload: {badgeChatTechnician},
});